<template>
  <b-container id="login">
    <b-row>
      <b-col>
        <h1>Login Required</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form :action="formUrl" method="POST">
          <b-form-group
              id="login"
              label="Hochschule Hof LDAP Login Data"
              label-for="login"
          >
            <b-form-input
                id="login"
                type="text"
                placeholder="Enter username like 'mmuster3'"
                name="username"
                required>
            </b-form-input>
            <b-form-input
                class="mt-1"
                id="login"
                type="password"
                placeholder="Enter password"
                name="password"
                required>
            </b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Login</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {
      formUrl: process.env.VUE_APP_API + "/web/login"
    }
  },
  methods: {

  }
}
</script>

<style scoped>
 #login {
   text-align: center;
 }
</style>